<div (click)="onClick()" class="d-flex justify-content-between">
  <div class="left-side">
    <div class="truncate-ellipsis" [mdbTooltip]="model.value" placement="bottom" (click)="onClick()">
      <div>
        <i *ngIf="model.photoUrl" appTitle class="fa fa-image mr-1"></i>
        <span class="font-weight-400" appTitle>{{model.value}}</span>
      </div>
    </div>
    <div class="truncate-ellipsis" [mdbTooltip]="model.issueNotificationTitle" placement="bottom" (click)="onClick()">
      <div>
        <span>{{model.issueNotificationTitle}}</span>
      </div>
    </div>
  </div>
  <div class="right-side">
    <div class="text-right font-size-08 text-truncate">
      <i class="fa fa-calendar mr-1 fa-lg color"></i>
      {{model.createdOn | date: applicationConfig.DATE_FORMAT}}
    </div>
    <div class="text-center mt-1 text-truncate">
      <span>{{Localization.By | translate | lowercase}}</span>
      <span>&nbsp;</span>
      <span class="font-weight-400 font-size-08">{{model.createdBy}}</span>
    </div>
  </div>
</div>
